module.exports = __webpack_public_path__ + "img/sgb.c82b5de1.jpg";